import { withDefault } from '../../core/util';
import {
  accountTypes,
  rolloverTypes,
  fundingTypes,
  isNonTrustTaxableOrContributory
} from '../../flows/shared/utils';

const getRolloverInfo = store => {
  const { app, rolloverType = null } = store;
  return [
    {
      accountName:
        rolloverType === rolloverTypes.DIRECT
          ? app.custodian.custodianName
          : 'Check',
      accountNumber: '',
      estimatedAmount: store.estimatedRolloverAmount
    }
  ];
};
// TODO [2022-1-12]: break this function up into multiple functions to pass complexity barrier
/* eslint-disable complexity */
const parseBankInfo = store => {
  const {
    app: { bankInformationReference },
    existingAccounts,
    loadedData,
    amount
  } = store;

  // information schema for funding section on review for existing bank
  if (
    bankInformationReference.bankChoiceMethod === fundingTypes.EXISTING_BANK
  ) {
    return [
      {
        accountName: withDefault(bankInformationReference?.bankName, ''),
        accountNumber: withDefault(
          bankInformationReference?.bankAccountNumber?.slice(-4),
          'XXXX'
        ),
        estimatedAmount: amount
      }
    ];
  }

  // handle Plaid in it's on conditional block
  // solves issues where plaidResult object isn't defined for Existing Banks or EVY scenarios
  if (bankInformationReference?.bankChoiceMethod === fundingTypes.EXTERNAL) {
    const {
      plaidResult: {
        externalAccount: { accountNumber }
      }
    } = loadedData;

    return [
      {
        accountName: withDefault(bankInformationReference.bankAccountType, ''),
        accountNumber: withDefault(accountNumber?.slice(-4), 'XXXX'),
        estimatedAmount: amount
      }
    ];
  }

  // default case is manual bank; EVY
  return [
    {
      accountName: withDefault(
        existingAccounts?.bankName || bankInformationReference?.bankName,
        ''
      ),
      accountNumber: withDefault(
        bankInformationReference?.bankAccountNumber?.slice(-4),
        'XXXX'
      ),
      estimatedAmount: amount
    }
  ];
};
/* eslint-enable complexity */

const getBankingInfo = store => {
  const {
    app: { fundingMethodType },
    amount
  } = store;

  // funding through existing bank, EVY, or Plaid
  if (fundingMethodType === fundingTypes.EFT) return parseBankInfo(store);

  // default to Check funding information
  return [
    {
      accountName: 'Check',
      accountNumber: '',
      estimatedAmount: amount
    }
  ];
};

const getTransferInfo = store => {
  const {
    app: { externalAccounts }
  } = store;

  return externalAccounts.map(account => ({
    accountName: account.accountName,
    accountNumber: account.accountNumber,
    estimatedAmount: account.estimatedTransferAmount
  }));
};

export const formatFundingInfo = store => {
  const { accountType, amount } = store;
  if (accountType === accountTypes.TRANSFER) {
    return getTransferInfo(store);
  }
  if (accountType === accountTypes.ROLLOVER) {
    return getRolloverInfo(store);
  }
  if (accountType === accountTypes.TRUST) {
    return [
      {
        accountName: 'Check',
        accountNumber: '',
        estimatedAmount: amount
      }
    ];
  }
  if (isNonTrustTaxableOrContributory(accountType)) {
    return getBankingInfo(store);
  }
  return [];
};

export const displayTaxableYear = store => {
  const { accountType, loadedData } = store;
  const isContrib = accountType === accountTypes.CONTRIBUTORY;
  const isTaxSeason =
    loadedData?.contributionPeriod?.withinPriorYearContributionPeriod;

  return isContrib && isTaxSeason;
};

export const taxableYearsToShow = store => {
  const { amount, priorYearAmount, currentYearAmount } = store;
  const {
    loadedData: {
      contributionPeriod: { currentYear, priorYear }
    }
  } = store;

  const arr = [];

  if (currentYearAmount > 0) arr.push(`$${currentYearAmount} (${currentYear})`);
  if (priorYearAmount > 0) arr.push(`$${priorYearAmount} (${priorYear})`);
  if (priorYearAmount > 0 && currentYearAmount > 0)
    arr.push(`$${amount} Total`);
  return arr.join(' / ');
};
